import { ROL_USER } from "../../app/api-client/constants"
import { TiLocation } from "react-icons/ti";
import { HiHome } from "react-icons/hi";
import { FaWeightScale, FaUsers } from "react-icons/fa6";
import { FaUserCog } from "react-icons/fa";
import { TbFilterEdit } from "react-icons/tb";
import { BsClipboard2DataFill } from "react-icons/bs";

export const RUTA_REGISTRO_MEDICIONES = "/mediciones/user/:nameBascula/:idBascula/mediciones/:documento";
export const RUTA_PREINFORME = "/mediciones/user/:nameBascula/:idBascula/preinforme/:documento";

export const menus = () => {

    const rol = localStorage.getItem(ROL_USER)

    const handledMenuByRol = () => {

        switch (rol) {
            case "ROLE_USER":
                return (

                    [

                        {
                            id: 1,
                            rol: "ROLE_USER",
                            icon: <HiHome />,
                            label: "Home",
                            type: "menu",
                            to: "/",
                            component: "DashboardInforme",
                            submenus: [],
                        },
                        {
                            id: 2,
                            rol: "ROLE_USER",
                            icon: <FaWeightScale />,
                            label: "Estaciones",
                            type: "menu",
                            to: "/basculas/",
                            isOpen: false,
                            component: "ListMachine",
                            submenus: [
                                {
                                    id: 3,
                                    icon: "timeline",
                                    label: "Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/mediciones/:id",
                                    component: "ImcGeneric"
                                },
                                {
                                    id: 20,
                                    icon: "timeline",
                                    label: "Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/:id",
                                    component: "Alcoholimetria",
                                }, {
                                    id: 51,
                                    icon: "timeline",
                                    label: "reporte",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/reporte/:id",
                                    component: "reporte"
                                },
                                {
                                    id: 32,
                                    icon: "assignmentTurnedIn",
                                    label: "Documentos",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/documentos/:id",
                                    component: "Documento"
                                },
                                {
                                    id: 33,
                                    icon: "assignmentTurnedIn",
                                    label: "Mantenimiento",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/mantenimiento/:id",
                                    component: "Mantenimiento"
                                },
                                {
                                    id: 30,
                                    icon: "assignmentTurnedIn",
                                    label: "Estaciones",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/result/:id/:idBas",
                                    component: "PollResult"
                                },
                                {
                                    id: 31,
                                    icon: "assignmentTurnedIn",
                                    label: "Preguntas",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/preguntas/:id",
                                    component: "PanelQuestion"
                                },
                                {
                                    id: 38,
                                    icon: "results",
                                    label: "resultados",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/results/:id",
                                    component: "graphicResults"
                                },
                                {
                                    id: 39,
                                    icon: "results",
                                    label: "resultados por usuario",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/resultsUSer/:id",
                                    component: "resultadoDeUsuario"
                                },

                                {
                                    id: 37,
                                    icon: "assignmentTurnedIn",
                                    label: "Respuestas",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/preguntas/respuestas/:id",
                                    component: "PanelResponse"
                                },
                                {
                                    id: 4,
                                    icon: "personAdd",
                                    label: "Usuarios",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:id",
                                    component: "UserTable",
                                }, {
                                    id: 5,
                                    icon: "personAdd",
                                    label: "Usuarios_detalle",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/detalles/user/:id",
                                    component: "UsersTableDetail",
                                }, {
                                    id: 6,
                                    icon: "personAdd",
                                    label: "Usuarios_profile",
                                    type: "submenu",
                                    show: false,
                                    to: "/users/profile",
                                    component: "ProfileUser",
                                },
                                {
                                    id: 8,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:nameBascula/:idBascula/historial/:documento",
                                    component: "historialUser",
                                },
                                {
                                    id: 300,
                                    icon: "personAdd",
                                    label: "preinforme_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_PREINFORME,
                                    component: "preinformeUser",
                                },
                                {
                                    id: 301,
                                    icon: "personAdd",
                                    label: "registro_mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_REGISTRO_MEDICIONES,
                                    component: "medicionesUser",
                                },
                                {
                                    id: 205,
                                    rol: "ROLE_USER",
                                    icon: <TiLocation />,
                                    label: "Ubicaciones",
                                    type: "menu",
                                    to: "/Ubicaciones",
                                    component: "Ubicaciones",
                                    isOpen: false,
                                    submenus: []
                                },
                            ],
                        },
                        {
                            id: 84,
                            rol: "ROLE_USER",
                            icon: <BsClipboard2DataFill />,
                            label: "Registros de Uso",
                            type: "menu",
                            isOpen: false,
                            to: "/RegistrosDeUso",
                            component: "RegistrosDeUso",
                            submenus: [],
                        },

                    ]

                )

            case "ROLE_ADMIN":
                return (
                    [
                        {
                            id: 1,
                            rol: "ROLE_ADMIN",
                            icon: <HiHome className="icontol" />,
                            label: "Home",
                            type: "menu",
                            to: "/",
                            component: "DashboardInforme",
                            submenus: [],
                        },
                        {
                            id: 2,
                            rol: "ROLE_USER",
                            icon: <FaWeightScale />,
                            label: "Estaciones",
                            type: "menu",
                            to: "/basculas/",
                            component: "ListMachine",
                            isOpen: false,
                            submenus: [
                                {
                                    id: 3,
                                    icon: "timeline",
                                    label: "Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/mediciones/:id",
                                    component: "ImcGeneric"
                                }, {
                                    id: 20,
                                    icon: "timeline",
                                    label: "Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/:id",
                                    component: "Alcoholimetria",
                                }, {
                                    id: 50,
                                    icon: "timeline",
                                    label: "reporte",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/reporte/:id",
                                    component: "reporte"
                                },
                                {
                                    id: 32,
                                    icon: "assignmentTurnedIn",
                                    label: "Documentos",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/documentos/:id",
                                    component: "Documento"
                                },
                                {
                                    id: 33,
                                    icon: "assignmentTurnedIn",
                                    label: "Mantenimiento",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/mantenimiento/:id",
                                    component: "Mantenimiento"
                                },
                                {
                                    id: 4,
                                    icon: "personAdd",
                                    label: "Usuarios",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:id",
                                    component: "UserTable",
                                }, {
                                    id: 5,
                                    icon: "personAdd",
                                    label: "Usuarios_detalle",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/detalles/user/:id",
                                    component: "UsersTableDetail",
                                }, {
                                    id: 6,
                                    icon: "personAdd",
                                    label: "Usuarios_profile",
                                    type: "submenu",
                                    show: false,
                                    to: "/users/profile",
                                    component: "ProfileUser",
                                },

                                {
                                    id: 8,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:nameBascula/:idBascula/historial/:documento",
                                    component: "historialUser",
                                },
                                {
                                    id: 300,
                                    icon: "personAdd",
                                    label: "preinforme_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_PREINFORME,
                                    component: "preinformeUser",
                                },
                                {
                                    id: 301,
                                    icon: "personAdd",
                                    label: "registro_mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_REGISTRO_MEDICIONES,
                                    component: "medicionesUser",
                                },
                                {
                                    id: 100,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/registro",
                                    component: "Registro",
                                },
                                {
                                    id: 9,
                                    rol: "ROLE_ADMIN",
                                    icon: <FaUsers />,
                                    label: "Usuarios",
                                    type: "submenu",
                                    to: "/Usuarios",
                                    component: "PanelUsersRegular",
                                    isOpen: false,
                                    submenus: [],
                                },
                                {
                                    id: 10,
                                    icon: "personAdd",
                                    label: "Usuarios",
                                    type: "submenu",
                                    to: "/estadisticas/users",
                                }, {
                                    id: 80,
                                    icon: "timeline",
                                    label: "Modulos",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/modulos/:id",
                                    component: "ListModulos"
                                },
                                {
                                    id: 81,
                                    icon: "timeline",
                                    label: "Modulos",
                                    type: "submenu",
                                    show: false,
                                    to: "/modulosgenerales",
                                    component: "ModulosGenerales"
                                },

                            ],

                        },
                        {
                            id: 84,
                            rol: "ROLE_ADMIN",
                            icon: <BsClipboard2DataFill />,
                            label: "Registros de Uso",
                            type: "menu",
                            isOpen: false,
                            to: "/RegistrosDeUso",
                            component: "RegistrosDeUso",
                            submenus: [],
                        },
                        {
                            id: 201,
                            rol: "ROLE_ADMIN",
                            icon: <FaUserCog />,
                            label: "Administracion",
                            type: "menu",
                            to: "/Administracion",
                            component: "Administracion",
                            isOpen: false,
                            submenus: [{
                                id: 200,
                                rol: "ROLE_ADMIN",
                                icon: "person",
                                label: "Clientes",
                                type: "submenu",
                                to: "/Clientes",
                                component: "Clientes",
                                isOpen: false,

                            },
                            {
                                id: 203,
                                rol: "ROLE_ADMIN",
                                icon: "person",
                                label: "EvbisAsignadas",
                                type: "submenu",
                                to: "/Clientes/EvbisAsignadas",
                                component: "EvbisAsignadas",


                            },
                            {
                                id: 202,
                                rol: "ROLE_ADMIN",
                                icon: "person",
                                label: "Años",
                                type: "submenu",
                                to: "/Años",
                                component: "Años",
                                isOpen: false,
                                submenus: []
                            },]
                        },


                        {
                            id: 204,
                            icon: <TiLocation />,
                            label: "Ubicaciones",
                            type: "menu",
                            to: "/Ubicaciones",
                            component: "Ubicaciones",
                            isOpen: false,
                            submenus: []
                        },
                        {
                            id: 201,
                            rol: "ROLE_ADMIN",
                            icon: <BsClipboard2DataFill />,
                            label: "Datos",
                            type: "menu",
                            to: "/Datos",
                            component: "Datos",
                            isOpen: false,
                            submenus: [
                                {
                                    id: 81,
                                    icon: "timeline",
                                    label: "Registro de Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/Registrodemediciones",
                                    component: "RegistroDeMediciones"
                                },
                                {
                                    id: 83,
                                    icon: "timeline",
                                    label: "Registro de Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/RegistroAlcohol",
                                    component: "RegistroAlcohol"
                                },
                                {
                                    id: 11,
                                    icon: <TbFilterEdit />,
                                    label: "Multifiltros",
                                    type: "submenu",
                                    to: "/Multifiltro",
                                    component: "MultifiltrosGeneral",
                                    isOpen: false,
                                    submenus: []
                                },
                                {
                                    id: 82,
                                    icon: "timeline",
                                    label: "Registro de Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/ValidacionDeCitas",
                                    component: "ValidacionDeCitas"
                                },
                            ]
                        },
                    ]
                )

            case "ROLE_SUPPORT":
                return (
                    [
                        {
                            id: 50,
                            rol: "ROLE_SUPPORT",
                            icon: "homeIcon",
                            label: "Home",
                            type: "menu",
                            to: "/",
                            component: "HomeSuport",
                            submenus: [],
                        },
                        {
                            id: 2,
                            rol: "ROLE_SUPPORT",
                            icon: <FaWeightScale />,
                            label: "Estaciones",
                            type: "menu",
                            to: "/basculas/",
                            component: "ListMachine",
                            isOpen: false,
                            submenus: [
                                {
                                    id: 3,
                                    icon: "timeline",
                                    label: "Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/mediciones/:id",
                                    component: "ImcGeneric"
                                }, {
                                    id: 20,
                                    icon: "timeline",
                                    label: "Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/:id",
                                    component: "Alcoholimetria",
                                }, {
                                    id: 50,
                                    icon: "timeline",
                                    label: "reporte",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/reporte/:id",
                                    component: "reporte"
                                },
                                {
                                    id: 32,
                                    icon: "assignmentTurnedIn",
                                    label: "Documentos",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/documentos/:id",
                                    component: "Documento"
                                },
                                {
                                    id: 33,
                                    icon: "assignmentTurnedIn",
                                    label: "Mantenimiento",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/mantenimiento/:id",
                                    component: "Mantenimiento"
                                },
                                {
                                    id: 4,
                                    icon: "personAdd",
                                    label: "Usuarios",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:id",
                                    component: "UserTable",
                                }, {
                                    id: 5,
                                    icon: "personAdd",
                                    label: "Usuarios_detalle",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/detalles/user/:id",
                                    component: "UsersTableDetail",
                                }, {
                                    id: 6,
                                    icon: "personAdd",
                                    label: "Usuarios_profile",
                                    type: "submenu",
                                    show: false,
                                    to: "/users/profile",
                                    component: "ProfileUser",
                                },

                                {
                                    id: 8,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:nameBascula/:idBascula/historial/:documento",
                                    component: "historialUser",
                                },
                                {
                                    id: 300,
                                    icon: "personAdd",
                                    label: "preinforme_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_PREINFORME,
                                    component: "preinformeUser",
                                },
                                {
                                    id: 301,
                                    icon: "personAdd",
                                    label: "registro_mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_REGISTRO_MEDICIONES,
                                    component: "medicionesUser",
                                },

                            ],

                        },
                        {
                            id: 84,
                            rol: "ROLE_SUPPORT",
                            icon: <BsClipboard2DataFill />,
                            label: "Registros de Uso",
                            type: "menu",
                            isOpen: false,
                            to: "/RegistrosDeUso",
                            component: "RegistrosDeUso",
                            submenus: [],
                        },
                    ])
            case "ROLE_CLIENT":
                return (

                    [

                        {
                            id: 1,
                            icon: <HiHome />,
                            label: "Home",
                            type: "menu",
                            to: "/",
                            component: "DashboardInforme",
                            submenus: [],
                        },
                        {
                            id: 2,
                            icon: <FaWeightScale />,
                            label: "Estaciones",
                            type: "menu",
                            to: "/basculas/",
                            isOpen: false,
                            component: "ListMachine",
                            submenus: [
                                {
                                    id: 3,
                                    icon: "timeline",
                                    label: "Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/mediciones/:id",
                                    component: "ImcGeneric"
                                },
                                {
                                    id: 20,
                                    icon: "timeline",
                                    label: "Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/:id",
                                    component: "Alcoholimetria",
                                }, {
                                    id: 51,
                                    icon: "timeline",
                                    label: "reporte",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/alcoholimetria/reporte/:id",
                                    component: "reporte"
                                },
                                {
                                    id: 32,
                                    icon: "assignmentTurnedIn",
                                    label: "Documentos",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/documentos/:id",
                                    component: "Documento"
                                },
                                {
                                    id: 33,
                                    icon: "assignmentTurnedIn",
                                    label: "Mantenimiento",
                                    show: false,
                                    type: "submenu",
                                    to: "/basculas/mantenimiento/:id",
                                    component: "Mantenimiento"
                                },
                                {
                                    id: 30,
                                    icon: "assignmentTurnedIn",
                                    label: "Estaciones",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/result/:id/:idBas",
                                    component: "PollResult"
                                },
                                {
                                    id: 31,
                                    icon: "assignmentTurnedIn",
                                    label: "Preguntas",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/preguntas/:id",
                                    component: "PanelQuestion"
                                },
                                {
                                    id: 4,
                                    icon: "personAdd",
                                    label: "Usuarios",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:id",
                                    component: "UserTable",
                                }, {
                                    id: 5,
                                    icon: "personAdd",
                                    label: "Usuarios_detalle",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/detalles/user/:id",
                                    component: "UsersTableDetail",
                                }, {
                                    id: 6,
                                    icon: "personAdd",
                                    label: "Usuarios_profile",
                                    type: "submenu",
                                    show: false,
                                    to: "/users/profile",
                                    component: "ProfileUser",
                                },

                                {
                                    id: 8,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/mediciones/user/:nameBascula/:idBascula/historial/:documento",
                                    component: "historialUser",
                                },
                                {
                                    id: 300,
                                    icon: "personAdd",
                                    label: "preinforme_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: RUTA_PREINFORME,
                                    component: "preinformeUser",
                                },
                                {
                                    id: 100,
                                    icon: "personAdd",
                                    label: "warning_bascula",
                                    type: "submenu",
                                    show: false,
                                    to: "/basculas/registro",
                                    component: "Registro",
                                },

                            ],
                        },
                        {
                            id: 204,
                            icon: <TiLocation />,
                            label: "Ubicaciones",
                            type: "menu",
                            to: "/Ubicaciones",
                            component: "Ubicaciones",
                            isOpen: false,
                            submenus: []
                        },
                        {
                            id: 84,
                            icon: <BsClipboard2DataFill />,
                            label: "Registros de Uso",
                            type: "menu",
                            isOpen: false,
                            to: "/RegistrosDeUso",
                            component: "RegistrosDeUso",
                            submenus: [],
                        },
                        {
                            id: 201,
                            icon: <BsClipboard2DataFill />,
                            label: "Datos",
                            type: "menu",
                            to: "/Datos",
                            component: "Datos",
                            isOpen: false,
                            submenus: [
                                {
                                    id: 81,
                                    icon: "timeline",
                                    label: "Registro de Mediciones",
                                    type: "submenu",
                                    show: false,
                                    to: "/Registrodemediciones",
                                    component: "RegistroDeMediciones"
                                },
                                {
                                    id: 821,
                                    icon: "timeline",
                                    label: "Registro de Alcoholimetria",
                                    type: "submenu",
                                    show: false,
                                    to: "/RegistroAlcohol",
                                    component: "RegistroAlcohol"
                                },
                                {
                                    id: 11,
                                    icon: <TbFilterEdit />,
                                    label: "Multifiltros",
                                    type: "submenu",
                                    to: "/Multifiltro",
                                    component: "MultifiltrosGeneral",
                                    isOpen: false,
                                    submenus: []
                                },
                            ]
                        },
                    ]

                )


            default:
                return ([])
        }

    }


    return (handledMenuByRol())

}
